import React, { useState, useEffect } from "react";
import { withRouter } from 'react-router-dom'

import { Grid, Box, CircularProgress } from "@material-ui/core";
import { PeopleAlt as PeopleAltIcon } from "@material-ui/icons";
import { Apartment as PropertyIcon } from "@material-ui/icons";


// styles
import useStyles from "./styles";
import "../../static/css/global.css";

//count effect
import CountUp from "react-countup";
// components
import Widget from "../../components/Widget";
import { Typography } from "../../components/Wrappers";

//context
import {
  useDashboardState, getTotalUsersOnPlatform
} from "../../context/DashboardContext";



import { Chart as ChartJs, Tooltip, Title, ArcElement, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';


ChartJs.register(
  Tooltip, Title, ArcElement, Legend
);

//Dashboard component
function Dashboard(props) {

  var classes = useStyles();
  const context = useDashboardState();
  var [users, setBackUsers] = useState(context.totalUsers.totalUsers);
  var [BasicUser, setBasicUser] = useState(0);
  var [ProUser, setProUser] = useState(0);

  //React hook which calls when page loads
  useEffect(() => {
    getTotalUsersOnPlatform(context.setTotalUsers)
  }, []); // eslint-disable-line

  //React hook which calls when context value change
  useEffect(() => {
    setBackUsers(context.totalUsers.totalUsers);
    if (context.totalUsers.totalUsers.data && context.totalUsers.totalUsers.data.basic_account_count) {
      setBasicUser(context.totalUsers.totalUsers.data.basic_account_count);
      setProUser(context.totalUsers.totalUsers.data.pro_account_count);
    }
  }, [context]);

  const data = {
    labels: ["Basic ",
      "Pro "],
    datasets: [
      {
        backgroundColor: [
          '#2B547E',
          '#f1981c',
        ],
        hoverBackgroundColor: [
          '#0a0a21',
          '#501800',
        ],
        data: [BasicUser, ProUser],
        animation: {
          duration: 3000
        },
        centertext: {
          display: true,
          text: "280"
        }
      }
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: false,
          font: {
            size: 14
          }
        }
      },
      title: {
        display: true,
        text: 'Basic / Pro Account',
        font: {
          size: 16
        },
      },
      centerText: {
        display: true,
        text: "280"
      }
    },
  };

  const handleNavigate = () => {
    props.history.push({ pathname: process.env.PUBLIC_URL + '/app/users' })
  };

  return (
    <Grid container spacing={3}>
      {!context.totalUsers.isLoaded || !users.data ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100vw"}
          height={"calc(100vh - 200px)"}
        >
          <CircularProgress size={50} />
        </Box>
      ) : (
        <>
          <Grid item lg={3} sm={6} xs={12} md={4}>
            <Widget
              bodyClass={classes.fullHeightBody}
              className={classes.card}
              disableWidgetMenu
              noBodyPadding
            >
              <Grid container spacing={3} onClick={handleNavigate}>
                <Grid item xs={12} style={{ display: 'flex', cursor: 'pointer' }}>
                  <Box className={classes.iconContainer}>
                    <PeopleAltIcon style={{ fontSize: '50px', color: '#ffffff' }} />
                  </Box>
                  <Box className={classes.totalContainer} >
                    <Typography variant="h2" weight="medium">
                      {context.totalUsers.totalUsers.data ?
                        <CountUp end={context.totalUsers.totalUsers.data.total_users} duration={1} /> : 0}
                    </Typography>
                    <Typography
                      color="text"
                      variant={"caption"}
                    >
                      Users
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Widget>
          </Grid>
          <Grid item lg={3} sm={6} xs={12} md={4}>
            <Widget
              bodyClass={classes.fullHeightBody}
              className={classes.card}
              disableWidgetMenu
              noBodyPadding
            >
              <Grid container spacing={3} >
                <Grid item xs={12} style={{ display: 'flex', cursor: 'pointer' }}>
                  <Box className={classes.iconContainer}>
                    <PropertyIcon style={{ fontSize: '50px', color: '#ffffff' }} />
                  </Box>
                  <Box className={classes.totalContainer}>
                    <Typography variant="h2" weight="medium">
                      {context.totalUsers.totalUsers.data ? <CountUp end={context.totalUsers.totalUsers.data.total_properties} duration={1} /> : 0}
                    </Typography>
                    <Typography
                      color="text"
                      variant={"caption"}
                    >
                      Properties
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Widget>
          </Grid>
          <Grid container spacing={5} style={{ marginTop: "10px" }}>
            <Grid item lg={3} sm={6} xs={12} md={4}  >
              <Doughnut
                data={data}
                options={options}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default withRouter(Dashboard);
